import type { IssueDependencyHardness, IssueDependencyType } from "@/domains/pm/types";

/** The four relationship types, in the order the editor lists them. */
export const DEPENDENCY_TYPES: IssueDependencyType[] = ["FS", "SS", "FF", "SF"];

/**
 * The shape an edge DRAWN IN THE GANTT takes.
 *
 * The gesture cannot ask for a relationship mid-drag, and dragging one bar onto
 * another means "this then that" — Finish → start, moving together.
 *
 * One definition, so the staged and the immediate add paths cannot drift — the
 * staged one used to spell these out while the immediate one relied on the
 * database's column defaults.
 */
export const DEFAULT_EDGE = {
  dep_type: "FS" as IssueDependencyType,
  lag_days: 0,
  hardness: "hard" as IssueDependencyHardness,
};

/**
 * What a new edge starts with in the PANEL, where the relationship is chosen
 * rather than assumed: no lag, and flexible until someone says otherwise.
 * `dep_type` is deliberately absent — see `DependencyDraftRow`.
 */
export const NEW_EDGE = {
  lag_days: 0,
  hardness: "soft" as IssueDependencyHardness,
};
